import styled, { css } from 'styled-components'
import { InstagramLogo, TrolleyIcon } from '@sainsburys-tech/bolt-icons'
import { Button } from '@sainsburys-tech/bolt'
import { C002Carousel, Icon, ImageContainer } from './types'

export const StyledHeadingContainer = styled.header`
  display: flex;
`

export const StyledImageContainer = styled.div<ImageContainer>`
  position: relative;
  min-width: 220px;

  ${(props) =>
    !props.isSains &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        min-width: 155px;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        min-width: 185px;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        min-width: 205px;
      }
    `}

  img {
    width: 100%;
    ${(props) =>
      props.isSains
        ? css`
            aspect-ratio: 1/1;
          `
        : css`
            height: 100%;
          `}
    cursor: pointer;
  }

  :hover {
    span {
      max-width: 160px;
    }

    label {
      display: inline;
    }
  }
`

const iconStyle = (isSains) =>
  css`
    path {
      fill: ${(props) => (isSains ? props.theme.color.monochrome.white : props.theme.color.monochrome.dark)};
    }
  `

export const StyledInstagramIcon = styled(InstagramLogo)<Icon>`
  ${(props) => iconStyle(props.isSains)}
  width: 30px;
  height: 30px;
  margin-left: ${(props) => props.theme.size.spacing.md};

  ${(props) =>
    props.isSains &&
    css`
      position: absolute;
      margin-left: 0;
      margin-right: ${props.theme.size.spacing.md};
      right: 0;
      bottom: 25%;
      cursor: pointer;
    `}
`

export const StyledTrolleyIcon = styled(TrolleyIcon)`
  ${iconStyle(false)}

  margin-right: ${(props) => props.theme.size.spacing.md};
`
export const StyledAuthorHandle = styled.p`
  position: absolute;
  left: 0;
  word-break: break-all;
  && {
    line-height: 1;
  }
`

export const StyledViewProductsIcon = styled.span`
  position: absolute;
  bottom: 15%;
  left: 0;
  margin-left: ${(props) => props.theme.size.spacing.sm};
  border-radius: ${(props) => props.theme.size.border.radius.xl};
  background-color: rgba(255, 255, 255, 0.75);
  height: auto;
  white-space: nowrap;
  transition: max-width 0.5s, padding-right 0.45s;
  overflow: hidden;
  padding: ${(props) => props.theme.size.spacing.md};
  min-width: 50px;
  max-width: 60px;
  cursor: pointer;
`

export const StyledViewProductsLabel = styled.label`
  display: none;
  padding-left: ${(props) => props.theme.size.spacing.md};
  cursor: pointer;
`

export const Carousel = styled.div<C002Carousel>`
  display: flex;
  gap: ${(props) => props.theme.size.spacing.lg};
`

export const SliderWrapper = styled.div`
  text-decoration: none;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
`

export const StyledButton = styled.button`
  all: unset;
  display: inline;
  width: 100%;
  height: 90%;

  :focus {
    outline: 5px auto -webkit-focus-ring-color;
  }
`

export const StyledCTALink = styled(Button)`
  height: 48px;
  margin-top: -${(props) => props.theme.size.spacing.md};
  :focus {
    outline: 5px auto -webkit-focus-ring-color;
    background-color: ${(props) => props.theme.color.palette['brand-1']};
  }
  ${(props) =>
    props.isCarousel &&
    css`
      position: absolute;
      bottom: 2%;
      :hover {
        background-color: ${props.theme.color.palette['brand-1']};
      }
    `};
`
